import { FC, Dispatch, ReactNode, SetStateAction, useContext, createContext } from "react";
import { Hotel } from "src/store/apis/Hotels";
import { SearchFormInputs } from "../../../constants/SearchPage";

type HotelBookingContextType = {
  hotel: Hotel;
  searchObject: SearchFormInputs;
  selectedRoomIndex: number | null;
  setSelectedRoomIndex: Dispatch<SetStateAction<number | null>>;
  selectedBookingCode: string | null;
  numberOfNights: number;
  pointsFactor: number;
  sessionId: string;
};

const HotelBookingContext = createContext<HotelBookingContextType | null>(null);

const HotelBookingProvider: FC<{ children: ReactNode; value: HotelBookingContextType }> = ({ children, value }) => {
  return <HotelBookingContext.Provider value={value}>{children}</HotelBookingContext.Provider>;
};

export default HotelBookingProvider;

export const useHotelBookingContext = () => {
  const context = useContext(HotelBookingContext);
  if (!context) throw new Error("Invalid usage outside of context");
  return context;
};
